import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { Amplify } from 'aws-amplify'
import config from './config'
import { Provider } from 'react-redux'
import store from './redux/store'
import { BrowserRouter as Router } from 'react-router-dom'
import ScrollToTop from 'components/scrollToTop'
import {
  CssBaseline,
  ThemeProvider,
  Theme,
} from '@mui/material'
import { StyledEngineProvider } from '@mui/material/styles'
import ErrorBoundary from 'components/errorBoundary'
import {
  StylesProvider,
  ThemeProvider as StylesThemeProvider,
  createGenerateClassName,
} from '@mui/styles'
import { theme } from 'shared/theme'
import { sendToGoogleAnalytics } from './reportWebVitals'
import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals'

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

// Keep legacy JSS class names stable while the app transitions to styled APIs.
const generateClassName = createGenerateClassName({ productionPrefix: 'muiv5' })

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
    },
  },
  API: {
    REST: {
      products: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
    },
  },
})

if (typeof window !== 'undefined') {
  ;(window as any).store = store
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Missing #root element')

createRoot(rootElement).render(
  <ErrorBoundary>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
          <StylesProvider generateClassName={generateClassName}>
            <StylesThemeProvider theme={theme}>
              <ThemeProvider theme={theme}>
                <Router>
                  <ScrollToTop />
                  <App />
                  <CssBaseline />
                </Router>
              </ThemeProvider>
            </StylesThemeProvider>
          </StylesProvider>
      </StyledEngineProvider>
    </Provider>
  </ErrorBoundary>
)

onCLS(sendToGoogleAnalytics)
onFCP(sendToGoogleAnalytics)
onINP(sendToGoogleAnalytics)
onLCP(sendToGoogleAnalytics)
onTTFB(sendToGoogleAnalytics)
